import i18n from "i18next";
import { filterNulls } from "src/utils/arrayUtils.ts";
import { TransformedConfigurationComponent } from "src/api/generated/erp/configurator/componentTransformation/model/transformedConfigurationComponent.ts";
import { groupConfiguratorComponentsToTabsAndSections } from "src/components/views/erp/configurator/configuratorForm/components/section/sectionGrouping.ts";

export function getConfiguratorFormErrors(components: TransformedConfigurationComponent[]): string[] {
	const allSections = groupConfiguratorComponentsToTabsAndSections(components).flatMap((tab) => tab.sections);

	return allSections.flatMap(({ sectionBreakComponent, childComponents }) => {
		if (sectionBreakComponent && !sectionBreakComponent.visible) {
			// Components inside hidden sections are considered non-existing and should not cause errors
			return [];
		}

		return filterNulls(childComponents.map((component) => getConfiguratorComponentErrorMessage(component)));
	});
}

export function getConfiguratorComponentErrorMessage(component: TransformedConfigurationComponent): string | undefined {
	if (component.type !== "field") return undefined;

	if (component.error != null && component.error.trim() !== "") {
		return component.error;
	}

	const value = component.currentValue;
	if (component.required && component.visible) {
		if (value.type !== "SCALAR" || value.propertyValue.type == "null" || value.propertyValue.value === "") {
			return i18n.t("configurator_component_error_required", { label: component.label });
		}
	}

	return undefined;
}
